<template>
  <div class="row">
    <div class="col-xl-8 col-lg-8 col-md-7 col-sm-6 col-12"></div>
    <div class="col-xl-4 col-lg-4 col-md-5 col-sm-6 col-6 text-right">
      <app-button-toggle
        :questionId="questionId"
        :expected-answer="answer.expectedAnswer"
        v-model="answer.expectedAnswer"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { BooleanAnswer } from "@/entities/questionaire/answers/BooleanAnswer";
import constants from "@/entities/constants";
import AppButtonToggle from "@/components/expert/AppButtonToggle.vue";

@Component({
  name: constants.answerTypes.BooleanAnswer.componentName,
  components: {
    AppButtonToggle
  }
})
export default class AppBooleanAnswer extends Vue {
  expected?: boolean | null;

  @Prop()
  questionId!: number;

  @Prop()
  answer!: BooleanAnswer;
}
</script>

<style scoped lang="scss">
@import "node_modules/bootstrap/scss/_functions.scss";
@import "node_modules/bootstrap/scss/_variables.scss";
@import "node_modules/bootstrap/scss/_mixins.scss";

@include media-breakpoint-down(xs) {
  .row {
    margin-bottom: 1rem !important;
  }
}
</style>
